import { configureStore } from "@reduxjs/toolkit";
import { authReducer } from "./features/auth";
import { authApi } from "./features/auth/authApi";
import { vendorApi } from "./features/vendors/vendorApi";
import { categoryApi } from "./features/categories/categoryApi";
import { productApi } from "./features/products/productApi";
import { orderApi } from "./features/orders/orderApi";
import { imageApi } from "./features/images/imageApi";
import { chatflowApi } from "./features/chatflows/chatflowApi";
import { chatBrandingApi } from "./features/chatflows/chatBrandingApi";
import { organizationApi } from "./features/organizations/organizationApi";
import { userApi } from "./features/users/userApi";
import { uglApi } from "./features/ugl/uglApi";
import { priceApi } from "./features/prices/priceApi";
import { smsApi } from "./features/sms/smsApi";
import { emailTemplateApi } from "./features/emailTemplates/emailTemplateApi";
import { csmApi } from "./features/csm/csmApi";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    // userSlice: userSlice,
    [authApi.reducerPath]: authApi.reducer,
    [vendorApi.reducerPath]: vendorApi.reducer,
    [categoryApi.reducerPath]: categoryApi.reducer,
    [productApi.reducerPath]: productApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [imageApi.reducerPath]: imageApi.reducer,
    [chatflowApi.reducerPath]: chatflowApi.reducer,
    [chatBrandingApi.reducerPath]: chatBrandingApi.reducer,
    [organizationApi.reducerPath]: organizationApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [uglApi.reducerPath]: uglApi.reducer,
    [priceApi.reducerPath]: priceApi.reducer,
    [smsApi.reducerPath]: smsApi.reducer,
    [emailTemplateApi.reducerPath]: emailTemplateApi.reducer,
    [csmApi.reducerPath]: csmApi.reducer,
    /*[occationApi.reducerPath]: occationApi.reducer,
    [emailTemplateApi.reducerPath]: emailTemplateApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [orderApi.reducerPath]: orderApi.reducer,
    [crmApi.reducerPath]: crmApi.reducer,
    [cardApi.reducerPath]: cardApi.reducer,
    [planApi.reducerPath]: planApi.reducer,*/
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      authApi.middleware,
      vendorApi.middleware,
      categoryApi.middleware,
      productApi.middleware,
      orderApi.middleware,
      imageApi.middleware,
      chatflowApi.middleware,
      chatBrandingApi.middleware,
      organizationApi.middleware,
      userApi.middleware,
      uglApi.middleware,
      priceApi.middleware,
      smsApi.middleware,
      emailTemplateApi.middleware,
      csmApi.middleware,
      /*occationApi.middleware,
      emailTemplateApi.middleware,
      userApi.middleware,
      orderApi.middleware,
      crmApi.middleware,
      cardApi.middleware,
      planApi.middleware,*/
    ]),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;